import HttpRequest from './HttpRequest'

const auth = {
  key: 'Authorization',
  value: 'Basic R2VudGxld29tYW46VGVzdDIwMTg='
}

export default class SmsProvider extends HttpRequest {
  constructor () {
    super('https://api.infobip.com/sms/1/text')
  }

  sendSingle (payload) {
    this.setHeader(auth)
    return this.post('/single', {
      to: payload.tel,
      text: payload.text,
      from: 'CAMPBKK'
    })
  }
}
